import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
// Style
import {
    Col,
    Tab,
    Tabs,
    FormGroup,
    FormControl
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames'
import history from '../../core/history';

// Graphql
import getAllReservationQuery from './getAllReservationQuery.graphql';

// Component
import Reservation from '../../components/Reservation';
import NoItem from '../../components/Reservation/NoItem';
import Loader from '../../components/Loader';
import CustomPagination from '../../components/CustomPagination';

// Locale
import messages from '../../locale/jsonMessages';
import debounce from '../../helpers/debounce';
import { withQuery } from '../../hoc/withGraphql';

import cs from '../../components/commonStyle.css';
import s from './Trips.css';

const Trips = (props) => {
    const {
        getAllReservation: { loading, getAllReservation, refetch },
        userType,
        type,
    } = props;
    const [currentPage, setCurrentPage] = useState(1);
    const [searchKey, setSearchKey] = useState('');
    const { formatMessage } = useIntl();

    useEffect(() => {
        refetch({ currentPage: 1, searchKey });
    }, [type])

    const paginationData = useCallback((page) => {
        setCurrentPage(page);
        refetch({ currentPage: page, searchKey });
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [refetch, searchKey])

    const handleSearch = useCallback(debounce(async (value) => {
        const { getAllReservation: { refetch } } = props;
        setCurrentPage(1);
        setSearchKey(value);
        refetch({ searchKey: value, currentPage: 1 });
    }), [])


    const handleSelect = useCallback((key) => {
        setCurrentPage(1);
        history.push(key === 1 ? '/trips/current' : '/trips/previous');
        refetch({ currentPage: 1, searchKey });
    }, [searchKey]);

    return (
        <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
            <div className={cx(cs.tripsReservationPanel, 'youcarsBg', 'bgBlack')}>
                <div className={cx('tabBarView', 'tabBarViewRTL')}>
                    <Tabs activeKey={type == 'current' ? 1 : 2} id="uncontrolled-tab-example" onSelect={(e) => handleSelect(e)}>
                        <Tab eventKey={1} title={<FormattedMessage {...messages.upcomingTab} />} />
                        <Tab eventKey={2} title={<FormattedMessage {...messages.previousTab} />} />
                    </Tabs>
                </div>
                <div className={cx(cs.spaceTop5, cs.spaceBottom4)}>
                    <FormGroup className={s.noMargin}>
                        <FormControl
                            type="text"
                            placeholder={formatMessage(messages.searchYourTrips)}
                            onChange={(e) => handleSearch(e.target && e.target.value)}
                            className='commonSearchIconInput searchFilterInputSize'
                            maxLength={255}
                            value={searchKey}
                        />
                    </FormGroup>
                </div>
                {loading && <Loader type="text" />}

                {
                    getAllReservation && getAllReservation?.reservationData?.length > 0 ? (
                        <div>
                            <Reservation data={getAllReservation.reservationData} userType={userType} type={type} />
                            <CustomPagination
                                total={getAllReservation.count}
                                currentPage={currentPage}
                                defaultCurrent={1}
                                defaultPageSize={5}
                                change={paginationData}
                                paginationLabel={formatMessage(messages.trips)}
                            />
                        </div>
                    ) : (
                        !loading && <NoItem userType={userType} type={type} />
                    )
                }
            </div>

        </Col>
    );
}

Trips.propTypes = {
    formatMessage: PropTypes.func,
    userType: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    data: PropTypes.shape({
        loading: PropTypes.bool.isRequired,
        getAllReservation: PropTypes.shape({
            count: PropTypes.number,
            reservationData: PropTypes.array
        }),
        refetch: PropTypes.func
    })
};

export default compose(
    withStyles(cs, s),
    withQuery(getAllReservationQuery,
        {
            name: 'getAllReservation',
            options: (props) => ({
                variables: {
                    searchKey: props.searchKey,
                    userType: props.userType,
                    dateFilter: props.type,
                    currentPage: props.currentPage,
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }
    ),
)(Trips);